export * from '../style';

const togglerArrowsEmXPadding = 0.15;

export {
  togglerArrowsEmXPadding
};
